$(document).ready(function () {
	setBackground();
	tabActive();
	swiperInit();
	toggleViewField();
	searchToggle();
	try {
		$.fancybox.defaults.parentEl = "form";
	} catch (error) {}
});

window.onscroll = function () {
	fixHeader();
};
$(document).ready(function () {
	jQuery(function ($) {
		"use strict";
		var counterUp = window.counterUp["default"]; // import counterUp from "counterup2"
		var $counters = $(".counter");
		/* Start counting, do this on DOM ready or with Waypoints. */
		$counters.each(function (ignore, counter) {
			var waypoint = new Waypoint({
				element: $(this),
				handler: function () {
					counterUp(counter, {
						duration: 3000,
						delay: 16,
					});
					this.destroy();
				},
				offset: "bottom-in-view",
			});
		});
	});
});

function searchToggle() {
	$(".search-toggle").on("click", function () {
		$(".searchbox").toggleClass("open");
		$(".search-toggle").toggleClass("icon-change");
		if ($(".header-top-banner").hasClass("hidden")) {
			$(".searchbox.open").css({
				top: "55px",
			});
		}
		event.preventDefault();
		$('.searchbox  > input[type="text"]').focus();
	});

	$(".searchbox, .searchbox .close").on("click keyup", function (event) {
		if (
			event.target == this ||
			event.target.className == "close" ||
			event.keyCode == 27
		) {
			$(this).removeClass("open");
			$(".search-toggle").removeClass("icon-change");
		}
	});
}

function swiperInit() {
	var employThumb = new Swiper(".swiper-empoyee-thumb .swiper", {
		spaceBetween: 10,
		slidesPerView: 2,
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});
	var employMain = new Swiper(".swiper-empoyee-main .swiper", {
		spaceBetween: 10,
		speed: 1205,
		autoplay: {
			delay: 3000,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".about-employee-swiper   .nav-next",
			prevEl: ".about-employee-swiper   .nav-prev",
		},
		thumbs: {
			swiper: employThumb,
		},
	});

	var historyThumb = new Swiper(" .swiper-history-thumb .swiper", {
		spaceBetween: 0,
		breakpoints: {
			200: {
				slidesPerView: 3,
				direction: "horizontal",
			},
			576: {
				slidesPerView: 4,
				direction: "horizontal",
			},

			1024: {
				slidesPerView: 6,
				direction: "vertical",
			},
			1280: {
				slidesPerView: 8,
				direction: "vertical",
			},
		},
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});
	var historyMain = new Swiper(".swiper-history-main .swiper", {
		spaceBetween: 10,
		speed: 1205,
		autoplay: {
			delay: 3000,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".about-history   .nav-next",
			prevEl: ".about-history   .nav-prev",
		},
		thumbs: {
			swiper: historyThumb,
		},
	});

	var swiperInvestThumb = new Swiper(" .swiper-invest-thumb", {
		spaceBetween: 15,
		breakpoints: {
			200: {
				slidesPerView: 3,
			},

			1280: {
				slidesPerView: 4,
			},
		},
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});
	var swiperInvestMain = new Swiper(".swiper-invest-main", {
		spaceBetween: 10,
		speed: 1205,
		autoplay: {
			delay: 3000,
		},
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".invest-detail  .nav-arrow-next",
			prevEl: ".invest-detail  .nav-arrow-prev",
		},
		thumbs: {
			swiper: swiperInvestThumb,
		},
	});

	// const homeProjectHome = new Swiper(".home-project .swiper", {
	// 	slidesPerView: 1,
	// 	speed: 1205,
	// 	autoplay: {
	// 		delay: 3000,
	// 	},
	// });

	const homeProjectMain = new Swiper('.home-project-first .swiper', {
		slidesPerView: 1,
		speed: 1205,
		autoplay: {
			delay: 3000
		},
		lazy: {
			loadPrevNext: true,
		},
		pagination: {
			el: '.home-project-first  .swiper-pagination',
			type: 'bullets',
			clickable: true
		},
	});
	var swiper = new Swiper(".mySwiper", {
		slidesPerView: 3,
		grid: {
			rows: 2,
		},
		spaceBetween: 30,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});

	const homeProjectSide = new Swiper('.home-project-second .swiper', {
		spaceBetween: 30,
		speed: 1205,
		autoplay: {
			delay: 3000
		},
		breakpoints: {
			200: {
				slidesPerView: 1,
			},
			576: {
				slidesPerView: 2,
			},

			// OLD
			1024: {
				slidesPerView: 1.2,
			},

			// NEW
			// 1024: {
			// 	slidesPerView: 1,
			// },
		},

	});

	const homerSwiper = new Swiper(".primary-banner .swiper", {
		slidesPerView: 1,
		speed: 1205,
		autoplay: {
			delay: 3000,
		},
		lazy: {
			loadPrevNext: true,
		},
		pagination: {
			el: ".primary-banner  .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
	});
	const topBanner = new Swiper(".top-banner .swiper", {
		slidesPerView: 1,
		speed: 1205,
		autoplay: {
			delay: 3000,
		},
		lazy: {
			loadPrevNext: true,
		},
		pagination: {
			el: ".primary-banner  .swiper-pagination",
			type: "bullets",
			clickable: true,
		},
	});

	$(".single-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("single-instance-" + index);
		$this
			.parent()
			.find(".nav-arrow-prev")
			.addClass("btn-prev-single-" + index);
		$this
			.parent()
			.find(".nav-arrow-next")
			.addClass("btn-next-single-" + index);
		$this
			.parent()
			.find(".swiper-pagination")
			.addClass("pagination-instance-single-" + index);
		var swiper = new Swiper(".single-instance-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			autoplay: {
				delay: 3000,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			slidesPerView: 1,
			navigation: {
				nextEl: ".btn-next-single-" + index,
				prevEl: ".btn-prev-single-" + index,
			},
			pagination: {
				el: ".pagination-instance-single-" + index,
				type: "bullets",
				clickable: true,
			},
		});
	});

	$(".trinity-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("tri-instance-" + index);
		$this
			.parent()
			.find(".nav-arrow-prev")
			.addClass("btn-prev-tri-" + index);
		$this
			.parent()
			.find(".nav-arrow-next")
			.addClass("btn-next-tri-" + index);
		$this
			.parent()
			.find(".swiper-pagination")
			.addClass("pagination-instance-tri-" + index);
		var swiper = new Swiper(".tri-instance-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			autoplay: {
				delay: 3000,
			},
			speed: 750,
			spaceBetween: 15,
			watchSlidesProgress: true,
			observer: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
				},
				400: {
					slidesPerView: 2,
				},
				576: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 3,
				},
			},
			navigation: {
				nextEl: ".btn-next-tri-" + index,
				prevEl: ".btn-prev-tri-" + index,
			},
			pagination: {
				el: ".pagination-instance-tri-" + index,
				type: "bullets",
				clickable: true,
			},
		});
	});
	$(".four-swiper .swiper").each(function (index, element) {
		var $this = $(this);
		$this.addClass("tri-instance-" + index);
		$this
			.parent()
			.find(".nav-arrow-prev")
			.addClass("btn-prev-four-" + index);
		$this
			.parent()
			.find(".nav-arrow-next")
			.addClass("btn-next-four-" + index);
		$this
			.parent()
			.find(".swiper-pagination")
			.addClass("pagination-instance-four-" + index);
		var swiper = new Swiper(".four-instance-" + index, {
			speed: 1205,
			lazy: {
				loadPrevNext: true,
			},
			autoplay: {
				delay: 3000,
			},
			speed: 750,
			observer: true,
			spaceBetween: 30,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				},
			},
			navigation: {
				nextEl: ".btn-next-four-" + index,
				prevEl: ".btn-prev-four-" + index,
			},
			pagination: {
				el: ".pagination-instance-four-" + index,
				type: "bullets",
				clickable: true,
			},
		});
	});
}

function toggleViewField() {
	$(".view-more-field-wrapper .block-wrap").each(function () {
		let x = 4;
		$(this).find(".block-content").slice(0, 5).show();
		let size = $(this).find(".block-content").length;
		if (size <= x) {
			$(this).parent().find(".btn-view-more").addClass("disable-btn");
		}
		$(".block-wrap")
			.parent()
			.find(".btn-view-more")
			.on("click", function (e) {
				e.preventDefault();
				x = x + 4;
				$(this)
					.parents(".view-more-field-wrapper")
					.find(".block-content")
					.slice(0, x)
					.slideDown();
				if (x >= size || size < x) {
					$(this)
						.parent()
						.find(".btn-view-more")
						.addClass("disable-btn");
				}
			});
	});
}

function fixHeader() {
	if ($(window).width() > 1025) {
		if (
			document.body.scrollTop > 100 ||
			document.documentElement.scrollTop > 100
		) {
			$("header").addClass("minimize");
		} else {
			$("header").removeClass("minimize");
		}
	}
}

//Tab active

function tabActive() {
	$(".tab-navigation li a").on("click", function () {
		$(this).parents(".tab-navigation").find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		var display = $(this).attr("data-type");
		$(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
	});
}
// Side
function setBackground() {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-size": "cover",
			"background-position": "center center",
		});
	});
	$("[setBackgroundRepeat]").each(function () {
		var background = $(this).attr("setBackgroundRepeat");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-repeat": "repeat",
		});
	});
}
